export interface PolygonAttribute {
  id: string;
  name: string;
  databaseID: string;
  values: PolygonAttributeValue[];
}

export interface PolygonAttributeValue {
  value: string;
  name: string;
}

export const polygonAttributes: PolygonAttribute[] = [
  {
    id: 'prt_slope_rg_view',
    name: 'Dominant Slope Class',
    databaseID: 'slope_rg',
    values: [
      { value: '1', name: 'NEARLY LEVEL 0 - 0.5%' },
      { value: '2', name: 'VERY GENTLE SLOPES 0.5 - 2%' },
      { value: '3', name: 'GENTLE SLOPES 2 - 5%' },
      { value: '4', name: 'MODERATE SLOPES 5 - 10%' },
      { value: '5', name: 'STRONG SLOPES 10 -15%' },
      { value: '6', name: 'STEEP SLOPES 15 -30 %' },
      { value: '7', name: 'VERY STEEP SLOPES >30%' },
    ],
  },
  {
    id: 'prt_slpl_view',
    name: 'Dominant Slope Length',
    databaseID: 'slpl',
    values: [
      { value: '1', name: '0 - 25 meters' },
      { value: '2', name: '25 - 50 meters' },
      { value: '3', name: '50 - 100 meters' },
      { value: '4', name: '100 - 500 meters' },
      { value: '5', name: '500 - 1000 meters' },
      { value: '6', name: '> 1000 meters' },
    ],
  },
  {
    id: 'prt_salsym_view',
    name: 'Salinity Effect on Production',
    databaseID: 'salsym',
    values: [
      { value: '1', name: 'None' },
      { value: '2', name: 'Very slight (2-4 mS/cm)' },
      { value: '3', name: 'Slight (4-8 mS/cm)' },
      { value: '4', name: 'Moderate (8-16 mS/cm)' },
      { value: '5', name: 'Severe (>16 mS/cm)' },
    ],
  },
  {
    id: 'prt_irrig_view',
    name: 'Initial Irrigation Potential',
    databaseID: 'irrig',
    values: [
      { value: '1', name: 'No soil or landscape limitations' },
      { value: '2', name: 'Moderate soil and/or landscape limitations' },
      { value: '3', name: 'Slight soil and/or landscape limitations' },
      { value: '4', name: 'Severe soil and/or landscape limitations' },
      { value: '5', name: 'Unclassified' },
    ],
  },
  {
    id: 'prt_text1_view',
    name: 'Dominant Texture',
    databaseID: 'text1',
    values: [
      { value: '1', name: 'Coarse' },
      { value: '2', name: 'Moderately coarse' },
      { value: '3', name: 'Medium' },
      { value: '4', name: 'Moderately fine' },
      { value: '5', name: 'Fine' },
      { value: '6', name: 'Organic' },
      { value: '7', name: 'Unclassified' },
    ],
  },
  {
    id: 'prt_text2_view',
    name: 'Subdominant Texture',
    databaseID: 'text2',
    values: [
      { value: '1', name: 'Coarse' },
      { value: '2', name: 'Moderately coarse' },
      { value: '3', name: 'Medium' },
      { value: '4', name: 'Moderately fine' },
      { value: '5', name: 'Fine' },
      { value: '6', name: 'Organic' },
      { value: '7', name: 'Unclassified' },
    ],
  },
  {
    id: 'phsym_style_css',
    name: 'pH',
    databaseID: 'phsym',
    values: [
      { value: '1', name: 'X: < 5.5' },
      { value: '2', name: 'A: 5.5 - 6.0' },
      { value: '3', name: 'B: 6.1 - 6.7' },
      { value: '4', name: 'C: 6.8 - 7.5' },
      { value: '5', name: 'D: > 7.5' },
    ],
  },
  {
    id: 'prt_pasteros_view',
    name: 'Historic Erosion Class',
    databaseID: 'pasteros',
    values: [
      { value: '1', name: 'WO - Very Low' },
      { value: '2', name: 'W1 - Low' },
      { value: '3', name: 'W2 - Moderate' },
      { value: '4', name: 'W3 - High' },
      { value: '5', name: 'W4 - Very High' },
      { value: '6', name: 'W5 - Extremely High' },
      { value: '7', name: 'Unclassified' },
    ],
  },
  {
    id: 'prt_stone_view',
    name: 'Stone Class',
    databaseID: 'stone',
    values: [
      { value: '1', name: 'Nonstony' },
      { value: '2', name: 'Slightly stony' },
      { value: '3', name: 'Moderately stony' },
      { value: '4', name: 'Very stony' },
      { value: '5', name: 'Exceedingly stony' },
      { value: '6', name: 'Unclassified' },
    ],
  },
  {
    id: 'prt_czone_view',
    name: 'Soil Zone',
    databaseID: 'czone',
    values: [
      { value: '1', name: 'BL' },
      { value: '2', name: 'BR' },
      { value: '3', name: 'DB' },
      { value: '4', name: 'DG' },
      { value: '5', name: 'G' },
      { value: '6', name: 'OR' },
      { value: '7', name: 'TB' },
    ],
  },
  {
    id: 'prt_order_view',
    name: 'Soil Order',
    databaseID: 'order3',
    values: [
      { value: '1', name: 'Brunisolic' },
      { value: '2', name: 'Chernozemic' },
      { value: '3', name: 'Cryosolic' },
      { value: '4', name: 'Gleysolic' },
      { value: '5', name: 'Luvisolic' },
      { value: '6', name: 'Organic' },
      { value: '7', name: 'Podzolic' },
      { value: '8', name: 'Regosolic' },
      { value: '9', name: 'Solonetzic' },
      { value: '10', name: 'Vertisolic' },
    ],
  },
];
